import React from 'react'
import "./style/Footer.css"
import {Link} from "react-router-dom"
export default function Footer() {
  return (
    <div className='footer'>
      <div className="contn">
         <Link to="/">Home</Link>
        <Link to="/aboutus">About us</Link>
        <Link to="/contact">Contact us</Link>
        <Link to="/privacypolicy">Privacy Policy</Link>
        <Link to="/disclamier">Disclaimer</Link>
      </div>
      <div className="copy">
        <p>Copyright © 2026
        </p>
        <p>Powered by <Link to="/mkcodewrites.com">mkCodeWrites</Link></p>
      </div>
    </div>
  )
}
